// Copyright (c) 2025 Audere, All Rights Reserved

import type { AuthState, OpenIdAuthData } from "../../types/auth";
import { apiSlice } from "../api/apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    openIdAuthenticate: builder.query<AuthState, string>({
      query: credential => ({
        url: "/openid_authenticate",
        method: "POST",
        headers: [["X-Audere-Token-Authority", "accounts.google.com"]],
        body: JSON.stringify({ credential }),
      }),
      keepUnusedDataFor: 0,
      transformResponse: (result: OpenIdAuthData, _meta, arg) => {
        return {
          email: result.email,
          name: result.name,
          picture: result.picture,
          credentials: arg,
          token: result.api_token,
          expires: result.api_token_valid_until,
          organizationId: "",
          roles: [],
        };
      },
    }),
  }),
});

export const { useLazyOpenIdAuthenticateQuery } = authApiSlice;
